import { render, staticRenderFns } from "./LoanProducts.vue?vue&type=template&id=6ba86b40&scoped=true&"
import script from "./LoanProducts.vue?vue&type=script&lang=js&"
export * from "./LoanProducts.vue?vue&type=script&lang=js&"
import style0 from "./LoanProducts.vue?vue&type=style&index=0&id=6ba86b40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba86b40",
  null
  
)

export default component.exports